import { Tag, Tooltip } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";
import { useCanSeeSoledeErpSync } from "./useCanSeeSoledeErpSync";

export function soledeSyncStatusColor(status) {
  switch (status) {
    case "submitted":
      return "green";
    case "rejected_already_in_erp":
      return "orange";
    case "rejected_error":
      return "red";
    case "skipped_cutoff":
      return "default";
    default:
      return undefined;
  }
}

/**
 * ERP transfer status tag (Solede). Hidden when user lacks visibility or when there is no status.
 * @param {{ soledeSync?: { status?: string, lastError?: string } }} props
 * @param {boolean} [props.showPlaceholder] — if true, show em dash when no status (e.g. list column)
 */
export function SoledeSyncStatusTag({ soledeSync, showPlaceholder = false }) {
  const { t } = useTranslation();
  const canSee = useCanSeeSoledeErpSync();
  if (!canSee) return null;

  const status = soledeSync?.status;
  if (!status) {
    if (!showPlaceholder) return null;
    return <span style={{ color: "#bbb" }}>—</span>;
  }

  const color = soledeSyncStatusColor(status);
  const tag = (
    <Tag size="middle" color={color} className="solede-sync-tag">
      {t("soledeSyncStatus." + status)}
    </Tag>
  );

  if (
    (status === "rejected_error" || status === "rejected_already_in_erp") &&
    soledeSync?.lastError
  ) {
    return <Tooltip title={soledeSync.lastError}>{tag}</Tooltip>;
  }
  return tag;
}
